<div class="login-form">
  <div class="login-logo">
    <img src="./assets/image/ancytree.logo.png" alt="">
  </div>
  <div class="login-content">
    <h1 i18n >Sign in</h1>
    <p i18n  >New user? <a [routerLink]="['/register-user']">Create account</a></p>
    <!-- <div class="facebook social">
      <img src="./assets/facebook.svg" alt="facebook">
      <div class="social-text">
        <p i18n >
          Continue with Facebook
        </p>
      </div>
    </div> -->

    <button class="btn google social" (click)="authService.GoogleAuth()">
      <img src="./assets/google.svg" alt="facebook">
      <div class="social-text">
        <p i18n >
          Continue with Google
        </p>    
      </div>
    </button>

    <div class="text-divider">
      <p i18n >
        Or email
      </p>
    </div>

    <form>
      <div class="input-group">
        <label i18n for="username">Email</label>
        <input type="text" name="username" id="username" placeholder="hi@ancytree.com" #userName required />
      </div>
      <div class="input-group">
        <label i18n for="password">Password</label>
        <div class="password-container">
          <input matInput name="password" [type]="passwordVisible ? 'text' : 'password'" id="password" #userPassword required/>
          <mat-icon (click)="this.passwordVisible = !this.passwordVisible">{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
        </div>
      </div>
      <div class="button-group">
        <button i18n (click)="authService.SignIn(userName.value, userPassword.value)">
          Sign in</button>
        <a i18n href="#" class="link" routerLink="/forgot-password">Forgot your password?</a>
      </div>
    </form>
  </div>
</div>